import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'

interface RecognizedTechnique {
  id: number;
  name: string;
  name_br?: string | null;
  recognition_count: number;
}

export const useMostRecognizedTechniques = (userId: string) => {
  return useQuery({
    queryKey: ['most-recognized-techniques', userId],
    queryFn: async (): Promise<RecognizedTechnique[]> => {
      const { data: { user } } = await supabase.auth.getUser()
      if (!user) {
        throw new Error('User not authenticated')
      }

      const { data, error } = await supabase.functions.invoke('get_most_recognized_techniques', {
        body: { target_user_id: userId }
      })

      if (error) {
        throw new Error(error.message)
      }

      return data.techniques || []
    },
    enabled: !!userId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
} 